import { useState, useLayoutEffect, useEffect } from 'react';
import { createMediaQueryListener } from './MediaQueryListener';
/* istanbul ignore next */
var globalWindow = typeof window !== 'undefined' ? window : null;
var useIsomorphicLayoutEffect = globalWindow ? useLayoutEffect : useEffect;
/**
 * Might not work on older browsers
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 * @param mediaQuery '(max-width: 600px)'
 * @return
 */
export function useMatchMediaQuery(mediaQuery) {
    var _a = useState(false), matches = _a[0], setMatches = _a[1];
    useIsomorphicLayoutEffect(function () {
        var listeners = [];
        if (globalWindow && typeof globalWindow.matchMedia === 'function') {
            var mediaQueryList = globalWindow.matchMedia(mediaQuery);
            // flag initial match
            setMatches(mediaQueryList.matches);
            // listener for changes
            listeners.push(createMediaQueryListener(mediaQueryList, function (ev) {
                setMatches(ev.matches);
            }));
        }
        return function () {
            // if no window exists, then no listeners will have been added
            for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                var listener = listeners_1[_i];
                listener.detach();
            }
        };
    }, [mediaQuery]);
    return matches;
}
//# sourceMappingURL=useMatchMediaQuery.js.map